import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Box, Typography } from '@mui/material';
import { fetchProducts } from '../redux/actions/productAction';
import { Products } from '../components/Products';

export const ProductsPage = () => {
  const dispatch = useDispatch();
  const { products, totalProducts } = useSelector((state) => state.products);
  const authUserId = useSelector(state => state?.auth?.user?.id);
  const token = useSelector((state) => state?.auth?.user?.accessToken?.token);
  const [model, setModel] = useState({});

  // useEffect(async () => {
  //   if (authUserId) {
  //     await dispatch(fetchProducts(model, authUserId, currentPage, pageSize, token));
  //   }
  // }, [dispatch, authUserId, currentPage, pageSize, model, token]);

  const handlePageChangeFilter = async () => {
    // setCurrentPage(1);
  };

  return (
    <Box sx={{ padding: 3 }}>
      <Box
        sx={{
          padding: 3,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          backgroundColor: '#FFFFFF',
          borderRadius: 3,
          boxShadow: '0 2px 8px rgba(13, 71, 161, 0.08)',
          border: '1px solid #E3F2FD',
          marginBottom: 4
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <Typography
            variant="h5"
            sx={{
              fontWeight: 600,
              color: '#1565C0',
              letterSpacing: '0.5px'
            }}
          >
            Ürünler
          </Typography>
        </Box>
      </Box>

      <Products 
        setModel={setModel}
        model = {model}         
      />
    </Box>
  );
};
